// We can't use URLSearchParams() because it would convert test = [1,2]
// to test="1,2" but Rails expects test[]=1&test[]=2
// Loosely based on jQuery's serialize.js implementation
function serializeParams(data) {
  if (!data) return ""

  return Object.keys(data).map((key) => serialize(key, data[key])).join("&")
}

function serialize(key, value) {
  if (Array.isArray(value)) {
    return value.map((v) => serialize(`${key}[]`, v)).join("&")
  } else if (value instanceof Object) {
    return Object.keys(value).map((valueKey) =>
      serialize(`${key}[${valueKey}]`, value[valueKey])
    ).join("&")
  }
  if (value === null) value = ""
  return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
}

export default serializeParams
